export default __webpack_public_path__ + "static/3-c2c516dd4cc74e929f7f5c526aece739.jpg";